:host {
  width: 100%;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host > div {
  position: relative;
  display: grid;
  width: calc(100% + calc(var(--space-unit) * 2));
  height: 402px;
  box-sizing: border-box;
  padding: calc(var(--space-unit) * 2) calc(var(--space-unit) * 3);
  border: var(--border-size-small) solid var(--color-primary01);
  margin-left: calc(-1 * var(--space-unit));
  background: var(--color-surface01);
  border-radius: 0;
  box-shadow: 0 2px 4px 0 rgb(66 69 72 / 35%);
}

:host > div > z-icon {
  position: absolute;
  top: var(--space-unit);
  right: var(--space-unit);
  cursor: pointer;
  fill: var(--color-primary01);
}

:host > div > div.cta-wrapper {
  display: flex;
  flex-flow: column nowrap;
  align-self: end;
  justify-content: space-between;
}

:host > div > div.content-wrapper {
  position: relative;
  overflow: hidden;
  align-self: stretch;
}

:host > div > div.content-wrapper > section {
  box-sizing: border-box;
  padding: var(--space-unit) 0;
  border-bottom: var(--border-size-small) solid var(--color-surface04);
  color: var(--color-surface05);
  font-size: 14px;
  line-height: 20px;
}

:host > div > div.content-wrapper > section:last-child {
  border-bottom: none;
}

:host > div > div.content-wrapper > section.info-wrapper {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

:host > div > div.content-wrapper > section.info-wrapper.hidden::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(180deg, rgb(255 0 0 / 0%), rgb(255 0 0 / 0%) 60%, white);
  content: "";
  pointer-events: none;
}

:host > div > div.content-wrapper > section > span.license-heading {
  display: flex;
  justify-content: space-between;
}

:host > div > div.content-wrapper > section > span.license-heading > span.expired {
  color: var(--color-primary01);
  font-size: 12px;
  font-weight: 600;
}

:host > div > div.content-wrapper > section > span.license-heading > span.expiring {
  color: var(--color-hover-warning);
  font-size: 12px;
  font-weight: 600;
}

:host > div > div.content-wrapper > z-popover {
  position: absolute;
  top: 0;
  left: calc(var(--space-unit) * 4);
}
